import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage, ContributorsPage } from "./screens/LandingPage";
import { JoinPage } from "./screens/JoinPage";
import { SignInPage } from "./screens/SignInPage";
import { DashboardPage } from "./screens/DashboardPage";
import { StraightUpMethodology } from "./screens/StraightUpMethodology/StraightUpMethodology";
import { SubMethodologyDetailPage } from "./screens/SubMethodologyDetail/SubMethodologyDetailPage";
import { AdminLogin } from "./screens/AdminAuth/AdminLogin";
import { AdminDashboard } from "./screens/AdminAuth/AdminDashboard";
import { AdminMethodologies } from "./screens/AdminAuth/AdminMethodologies";
import { SubMethodologyContentPage } from "./screens/AdminAuth/SubMethodologyContentPage";
import { AdminGuidedMethodologies } from "./screens/AdminAuth/AdminGuidedMethodologies";
import { GuidedMethodologyDetail } from "./screens/AdminAuth/GuidedMethodologyDetail";
import { GuidedMethodologiesPage } from "./screens/GuidedMethodologies/GuidedMethodologiesPage";
import { GuidedMethodologyPage } from "./screens/GuidedMethodologies/GuidedMethodologyPage";
import { AdminUserManagement } from "./screens/AdminAuth/AdminUserManagement";
import { AdminSettings } from "./screens/AdminAuth/AdminSettings";
import { AllMethodologies } from "./screens/AdminAuth/AllMethodologies";
import { AdminNotes } from "./screens/AdminAuth/AdminNotes";
import { AdminHuntingToolkit } from "./screens/AdminAuth/AdminHuntingToolkit";
import { AdminToolkitPage } from "./screens/AdminAuth/AdminToolkitPage";
import { AdminLOLBASPage } from "./screens/AdminAuth/AdminLOLBASPage";
import { AdminGTFOBinsPage } from "./screens/AdminAuth/AdminGTFOBinsPage";
import { AdminWADComsPage } from "./screens/AdminAuth/AdminWADComsPage";
import { ToolkitPage } from "./screens/ToolkitPage";
import { HuntingToolkitPage } from "./screens/HuntingToolkitPage";
import { LOLBASPage } from "./screens/LOLBASPage";
import { GTFOBinsPage } from "./screens/GTFOBinsPage/GTFOBinsPage";
import { BinaryDetailPage } from "./screens/GTFOBinsPage/BinaryDetailPage";
import { RAWPAAIPage } from "./screens/RAWPA_AI/RAWPAAIPage";
import { Toaster } from "./components/ui/toaster";
import { SystemSettingsProvider } from "./lib/SystemSettingsContext";
import RouteGuard from "./components/RouteGuard";
import { PathwayMethodology } from "./screens/PathwayMethodology/PathwayMethodology";
import { WADComsPage } from "./screens/WADComsPage/WADComsPage";
import { ReverseShellPage } from "./screens/ReverseShellPage";
import { AdminReverseShellPage, AdminOSINTPage, TwoFactorSetup, TwoFactorVerification, TwoFactorManagement } from "./screens/AdminAuth";
import { OSINTToolkitPage } from "./screens/OSINTToolkitPage";
import { AdminContributionsPage } from "./screens/AdminAuth";
import { AdminNeuralNetwork } from "./screens/AdminAuth/AdminNeuralNetwork";
import { AdminNeuralFeedback } from "./screens/AdminAuth/AdminNeuralFeedback";
import { PentestOrchestratorPage } from "./screens/PentestOrchestrator";
import HuntersBoardPage from './screens/HuntersBoardPage';
import ProfilePage from './screens/ProfilePage';
import { AdminHackerChecklists } from "./screens/AdminAuth/AdminHackerChecklists";
import { HackerChecklistsPage } from "./screens/HackerChecklists/HackerChecklistsPage";
import { HackerChecklistDetailPage } from "./screens/HackerChecklists/HackerChecklistDetailPage";

// Export as both default and named export
export function App() {
  return (
    <SystemSettingsProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/join" element={
            <RouteGuard checkSetting="disableSignup" redirectTo="/">
              <JoinPage />
            </RouteGuard>
          } />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          
          {/* Protected methodology routes */}
          <Route path="/methodology/guided" element={
            <RouteGuard checkSetting="disableGuidedMethodologies">
              <GuidedMethodologiesPage />
            </RouteGuard>
          } />
          <Route path="/methodology/guided/:methodologyId" element={
            <RouteGuard checkSetting="disableGuidedMethodologies">
              <GuidedMethodologyPage />
            </RouteGuard>
          } />
          <Route path="/methodology/pathway" element={<PathwayMethodology />} />
          <Route path="/methodology/:methodologyId" element={
            <RouteGuard checkSetting="disableStraightUpMethodologies">
              <StraightUpMethodology />
            </RouteGuard>
          } />
          <Route path="/methodology/:methodologyId/:subMethodologyId" element={
            <RouteGuard checkSetting="disableStraightUpMethodologies">
              <SubMethodologyDetailPage />
            </RouteGuard>
          } />
          <Route path="/guided-methodologies" element={
            <RouteGuard checkSetting="disableGuidedMethodologies">
              <GuidedMethodologiesPage />
            </RouteGuard>
          } />
          <Route path="/guided-methodologies/:methodologyId" element={
            <RouteGuard checkSetting="disableGuidedMethodologies">
              <GuidedMethodologyPage />
            </RouteGuard>
          } />
          <Route path="/rawpa-ai" element={
            <RouteGuard checkSetting="disableAI">
              <RAWPAAIPage />
            </RouteGuard>
          } />
          <Route path="/pentest-orchestrator" element={
            <RouteGuard checkSetting="disablePentestOrchestrator">
              <PentestOrchestratorPage />
            </RouteGuard>
          } />
          <Route path="/toolkits" element={<ToolkitPage />} />
          <Route path="/toolkits/hunting-toolkit" element={<HuntingToolkitPage />} />
          <Route path="/toolkits/lolbas" element={<LOLBASPage />} />
          <Route path="/toolkits/gtfobins" element={<GTFOBinsPage />} />
          <Route path="/toolkits/gtfobins/:binaryName" element={<BinaryDetailPage />} />
          <Route path="/toolkits/wadcoms" element={<WADComsPage />} />
          <Route path="/toolkits/reverse-shell" element={<ReverseShellPage />} />
          <Route path="/toolkits/osint" element={<OSINTToolkitPage />} />
          <Route path="/hacker-checklists" element={
            <RouteGuard checkSetting="disableHackerChecklists">
              <HackerChecklistsPage />
            </RouteGuard>
          } />
          <Route path="/hacker-checklists/:checklistId" element={
            <RouteGuard checkSetting="disableHackerChecklists">
              <HackerChecklistDetailPage />
            </RouteGuard>
          } />
          
          {/* Admin routes - using obscured path for security */}
          <Route path="/aAyuiOcvMq" element={<AdminLogin />} />
          <Route path="/aAyuiOcvMq/login" element={<AdminLogin />} />
          <Route path="/aAyuiOcvMq/2fa-setup" element={<TwoFactorSetup />} />
          <Route path="/aAyuiOcvMq/2fa-verify" element={<TwoFactorVerification />} />
          <Route path="/aAyuiOcvMq/two-factor-auth" element={<TwoFactorManagement />} />
          <Route path="/aAyuiOcvMq/admin" element={<AdminDashboard />} />
          <Route path="/aAyuiOcvMq/dashboard" element={<AdminDashboard />} />
          <Route path="/aAyuiOcvMq/all-methodologies" element={<AllMethodologies />} />
          <Route path="/aAyuiOcvMq/methodologies" element={<AdminMethodologies />} />
          <Route path="/aAyuiOcvMq/guided-methodologies" element={<AdminGuidedMethodologies />} />
          <Route path="/aAyuiOcvMq/guided-methodologies/:methodologyId" element={<GuidedMethodologyDetail />} />
          <Route path="/aAyuiOcvMq/users" element={<AdminUserManagement />} />
          <Route path="/aAyuiOcvMq/settings" element={<AdminSettings />} />
          <Route path="/aAyuiOcvMq/hunting-toolkit" element={<AdminHuntingToolkit />} />
          <Route path="/aAyuiOcvMq/methodology/:methodologyId/sub-methodology/:subMethodologyId/content" element={<SubMethodologyContentPage />} />
          <Route path="/aAyuiOcvMq/notes" element={<AdminNotes />} />
          <Route path="/aAyuiOcvMq/pathway-methodology" element={<AdminNeuralNetwork />} />
          <Route path="/aAyuiOcvMq/toolkit" element={<AdminToolkitPage />} />
          <Route path="/aAyuiOcvMq/hacker-checklists" element={<AdminHackerChecklists />} />
          <Route path="/aAyuiOcvMq/lolbas" element={<AdminLOLBASPage />} />
          <Route path="/aAyuiOcvMq/gtfobins" element={<AdminGTFOBinsPage />} />
          <Route path="/aAyuiOcvMq/wadcoms" element={<AdminWADComsPage />} />
          <Route path="/aAyuiOcvMq/reverse-shell" element={<AdminReverseShellPage />} />
          <Route path="/aAyuiOcvMq/osint" element={<AdminOSINTPage />} />
          <Route path="/aAyuiOcvMq/contributions" element={<AdminContributionsPage />} />
          <Route path="/aAyuiOcvMq/neural-network" element={<AdminNeuralNetwork />} />
          <Route path="/aAyuiOcvMq/neural-feedback" element={<AdminNeuralFeedback />} />
          <Route path="/contributors" element={<ContributorsPage />} />
          <Route path="/hunters-board" element={<HuntersBoardPage />} />
        </Routes>
        <Toaster />
      </Router>
    </SystemSettingsProvider>
    
  );
}

// Default export
export default App;